// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.a6qlsyOmrEPPyBJdCLNY{text-align:center;color:var(--content-primary-tertiary);justify-content:center;display:flex}.a6qlsyOmrEPPyBJdCLNY a.q0FZkDm2gZQXLazAbOeQ{color:var(--content-brand-primary)}.a6qlsyOmrEPPyBJdCLNY a.q0FZkDm2gZQXLazAbOeQ:hover{color:var(--content-brand-secondary)}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrap": `a6qlsyOmrEPPyBJdCLNY`,
	"link": `q0FZkDm2gZQXLazAbOeQ`
};
export default ___CSS_LOADER_EXPORT___;
